export type ErrorDiagnostics = {
  component?: string;
  phase?: string;
  csrBuildId?: string;
  ssrBuildId?: string;
  workerBloc?: string;
  channel?: string;
};

const errorDiagnostics: WeakMap<object, ErrorDiagnostics> = new WeakMap<object, ErrorDiagnostics>();

export function attachErrorDiagnostics(error: unknown, diagnostics: ErrorDiagnostics): void {
  if ((typeof error !== 'object' || error === null) && typeof error !== 'function') {
    return;
  }
  // Keep the first observed origin without mutating frozen, shared, or foreign errors.
  errorDiagnostics.set(error, { ...diagnostics, ...errorDiagnostics.get(error) });
}

export function getErrorDiagnostics(error: unknown): ErrorDiagnostics | undefined {
  if ((typeof error !== 'object' || error === null) && typeof error !== 'function') {
    return undefined;
  }
  return errorDiagnostics.get(error);
}
